import * as React from 'react';
import { Link } from 'react-scroll';
import { MediaQuery, Util } from '@grandvisionhq/common';
import { Heading } from '@grandvisionhq/elements';
import { Icon } from '@grandvisionhq/icons';

// fixed navigation height needed for anchor scrolling
const siteNavHeightOffset = -64;
const BlogDetailHeader = ({ image , mobileImage , title , scrollTo  })=>{
    const isSmallScreen = MediaQuery.useIsBelow(MediaQuery.BreakpointName.TABLET_LANDSCAPE);
    const imageUrl = isSmallScreen && mobileImage ? mobileImage.url : image.url;
    if (!imageUrl) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: "blog-detail-header",
        style: Util.createCssImageSetStyle(imageUrl, isSmallScreen ? 1024 : 1920, {
            fit: 'scale'
        }, {
            extraPixelDensities: [
                2
            ],
            style: {
                backgroundPosition: 'center',
                backgroundSize: 'cover'
            }
        })
    }, /*#__PURE__*/ React.createElement(Heading, {
        className: "blog-detail-header__title"
    }, title), /*#__PURE__*/ React.createElement(Link, {
        className: "blog-detail-header__link",
        href: "#",
        to: scrollTo,
        offset: siteNavHeightOffset,
        smooth: true,
        duration: 500
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: "chevron-down"
    })));
};
var BlogDetailHeader$1 = BlogDetailHeader;

export { BlogDetailHeader$1 as default };
//# sourceMappingURL=BlogDetailHeader.js.map
